import React, { useState, useEffect } from "react";
import css from "../Form.module.css"; // Now actively importing your CSS module
const Slider = ({ children, onChange }) => {
  const { label, max, min, placeholder, parse } = children;
  const initialValue = Number(children.value) || 0;
  const [value, setValue] = useState(Math.max(min, Math.min(max, initialValue)));

  const handleChange = (event) => {
    const newValue = Number(event.target.value);
    setValue(newValue);

    if (parse?.array && parse?.index !== undefined && parse?.set) {
      const target = parse.array[parse.index];
      if (target && typeof target === "object") {
        target[parse.set] = newValue;
        console.log(`✅ Updated score at index ${parse.index}:`, parse.array);
      } else {
        console.warn(`⚠️ Invalid target at index ${parse.index}`);
      }
    }

    onChange && onChange(newValue);
  };

  const fillPercentage = max > min ? ((value - min) / (max - min)) * 100 : 0;
  const filledColor = 'var(--electricblue)';
  const unfilledColor = '#ccc';

  return (
    <div className={css.FormControl}>
      <div>
        <label>{label}</label>
        <div className={css.SliderDetails}>
          <p className={css.SliderDetailsPlaceholder}>{placeholder}</p>
          <p className={css.SliderDetailsValue}>{value}</p>
        </div>
      </div>
      <div className={css.SliderTrackWrapper}>
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          style={{
            background: `linear-gradient(to right, ${filledColor} 0%, ${filledColor} ${fillPercentage}%, ${unfilledColor} ${fillPercentage}%, ${unfilledColor} 100%)`,
          }}
        />
      </div>
    </div>
  );
};


export default Slider;
